<template>
  <mi-drawer
    class=" configuration-restore-point-drawer"
    :model-value="true"
    :mini="!opened"
    width="355"
    mini-width="57"
    side="right"
    bordered
    overlay
    persistent
  >
    <mi-list-item class="q-pa-md" :class="!opened ? 'mini-drawer' : ''">
      <mi-btn
        :ripple="false"
        icon="arrows-right"
        icon-type
        icon-size="18px"
        class="collapse-icon drawer-btn q-mt-sm"
        :class="{ 'rotate-180': !opened }"
        dense
        fab
        flat
        @click="toggleActiveTab(lastOpenedTabKey)"
      ></mi-btn>
      <mi-btn
        v-show="!opened"
        :ripple="false"
        icon="settings"
        class="drawer-btn"
        icon-type
        icon-size="18px"
        dense
        fab
        flat
        @click="toggleActiveTab(tabs.PROPERTIES.key)"
      >
        <mi-tooltip anchor="center left" self="center right">Properties</mi-tooltip>
      </mi-btn>
      <mi-btn
        v-show="!opened"
        :ripple="false"
        icon="stopwatch-outline"
        class="drawer-btn"
        icon-type
        icon-size="18px"
        data-testid="restore-point"
        dense
        fab
        flat
        @click="toggleActiveTab(tabs.RESTORE_POINT.key)"
      >
        <mi-tooltip anchor="center left" self="center right">Configuration Restore</mi-tooltip>
      </mi-btn>
    </mi-list-item>
    <mi-list-item v-show="opened" class="items-center config-restore-tabs">
      <configuration-restore-point-tabs
        :configuration="configuration"
        :open-edit-dialog="toggleIsConfigurationEditDialogShown"
        :toggle-open-side-drawer="toggleOpenSideDrawer"
      ></configuration-restore-point-tabs>
    </mi-list-item>
  </mi-drawer>
  <!-- Edit configuration dialog -->
  <configuration-edit-dialog v-model="isConfigurationEditDialogShown" :options="options"></configuration-edit-dialog>
</template>

<script>
  import { computed, provide, ref } from 'vue'
  import { useStore } from 'vuex'
  import { LocalStorage } from 'quasar'
  import { CONFIG_RESTORE_RECENT_TAB_PROVIDER, CONFIGURATION_RESTORE_POINT_TABS } from '../../../../constants'
  import ConfigurationRestorePointTabs from './tabs/ConfigurationRestorePointTabs.vue'
  import MiListItem from '../../../../packages/@mi-library/MiList/MiListItem.vue'
  import ConfigurationEditDialog from '../dialogs/ConfigurationEditDialog.vue'

  export default {
    name: 'ConfigurationRestorePointDrawer',
    components: { ConfigurationEditDialog, MiListItem, ConfigurationRestorePointTabs },
    props: {
      opened: {
        type: Boolean,
        required: true
      },
      toggleOpenSideDrawer: {
        type: Function,
        required: true
      },
      options: {
        type: Array,
        required: true
      }
    },
    setup(props) {
      const isConfigurationEditDialogShown = ref(false)
      const tabs = ref(CONFIGURATION_RESTORE_POINT_TABS)
      const lastOpenedTabKey = ref('last-opened')
      const activeTab = ref('')
      provide(CONFIG_RESTORE_RECENT_TAB_PROVIDER, activeTab)

      const store = useStore()
      const configuration = computed(() => store?.state?.pac?.currentConfiguration)

      const toggleActiveTab = value => {
        if (value === lastOpenedTabKey.value) {
          activeTab.value = LocalStorage.getItem(process.env.VUE_APP_STORAGE_KEY_CONFIG_RESTORE_RECENT_TAB)
            || CONFIGURATION_RESTORE_POINT_TABS.PROPERTIES.key
        }
        else {
          activeTab.value = value
        }
        props.toggleOpenSideDrawer()
      }

      const toggleIsConfigurationEditDialogShown = () => {
        isConfigurationEditDialogShown.value = !isConfigurationEditDialogShown.value
      }

      return {
        toggleActiveTab,
        tabs,
        lastOpenedTabKey,
        activeTab,
        configuration,
        isConfigurationEditDialogShown,
        toggleIsConfigurationEditDialogShown
      }
    }
  }
</script>

<style lang="scss" scoped>
  .q-item {
    padding: 0;
  }

  .mini-drawer {
    width: 100%;
  }

  .mi-list-item {
    flex-direction: column;
    align-items: flex-end;
  }

  .drawer-btn {
    margin: 8px 10px 0;
  }

  .q-btn {
    padding-right: 0;
  }

  // stylelint-disable declaration-no-important
  ::v-deep(.q-drawer) {
    top: 108px !important;
  }

  ::v-deep(.scroll) {
    overflow: hidden !important;
  }

  ::v-deep(.q-icon) {
    margin-right: 0 !important;
    padding: 0 !important;
  }
</style>
